export const ROUTES = {
  home: {
    dashboards: {
      base: '/dashboards',
      detail: '/dashboards/:id'
    },
    member: {
      base: '/members',
      detail: '/members/:id'
    },
    transaction: {
      base: '/transactions',
      detail: '/transactions/:id'
    }
  },
  login: '/login',
  signUp: '/signup',
  forgotPassword: '/forgot-password'
}
